<div class="metin-notu-dialog">
  <!-- Toolbar - Point Selection -->
  <div class="catia-toolbar">
    <div class="toolbar-grup">
      <div class="ayar-satir">
        <button class="catia-btn" [class.active]="nokta" (click)="noktaSec()"
                style="flex: 1; background: linear-gradient(135deg, rgba(255, 68, 68, 0.15), rgba(255, 68, 68, 0.25)); border-color: rgba(255, 68, 68, 0.4); color: #FF4444;">
          <i class="icon map marker alternate"></i>
          {{nokta ? 'Nokta Seçildi ✓' : 'Nokta Seç'}}
        </button>
      </div>
    </div>
  </div>

  <!-- Control Panel -->
  <div class="kontrol-paneli">

    <!-- Bayrak Ayarları -->
    <div class="ayar-sekme">
      <div class="sekme-baslik" (click)="bayrakAyarlariAcik = !bayrakAyarlariAcik">
        <i class="icon flag"></i>
        <span>Bayrak Ayarları</span>
        <div class="chevron" [class.right]="!bayrakAyarlariAcik" [class.down]="bayrakAyarlariAcik"></div>
      </div>

      @if (bayrakAyarlariAcik) {
      <div class="sekme-icerik">
        <!-- Metin -->
        <div class="ayar-satir">
          <label>Metin:</label>
          <input type="text" [(ngModel)]="metin" (ngModelChange)="onizlemeGuncelle()"
                 class="catia-input" placeholder="Bayrak metni..." />
        </div>

        <!-- Kutup Yüksekliği -->
        <div class="ayar-satir">
          <label>Kutup Yüks.:</label>
          <div class="slider-kontrol">
            <input type="range" [(ngModel)]="kutupYuksekligi" (ngModelChange)="onizlemeGuncelle()"
                   min="0.5" max="3" step="0.1" />
            <span class="deger-gosterge">{{kutupYuksekligi.toFixed(1)}}</span>
          </div>
        </div>

        <!-- Bayrak Genişliği -->
        <div class="ayar-satir">
          <label>Genişlik:</label>
          <div class="slider-kontrol">
            <input type="range" [(ngModel)]="bayrakGenisligi" (ngModelChange)="onizlemeGuncelle()"
                   min="0.3" max="1.5" step="0.1" />
            <span class="deger-gosterge">{{bayrakGenisligi.toFixed(1)}}</span>
          </div>
        </div>

        <!-- Bayrak Yüksekliği -->
        <div class="ayar-satir">
          <label>Yükseklik:</label>
          <div class="slider-kontrol">
            <input type="range" [(ngModel)]="bayrakYuksekligi" (ngModelChange)="onizlemeGuncelle()"
                   min="0.2" max="1" step="0.05" />
            <span class="deger-gosterge">{{bayrakYuksekligi.toFixed(2)}}</span>
          </div>
        </div>
      </div>
      }
    </div>

    <!-- Görünüm Ayarları -->
    <div class="ayar-sekme">
      <div class="sekme-baslik" (click)="gorunumAyarlariAcik = !gorunumAyarlariAcik">
        <i class="icon eye"></i>
        <span>Görünüm Ayarları</span>
        <div class="chevron" [class.right]="!gorunumAyarlariAcik" [class.down]="gorunumAyarlariAcik"></div>
      </div>

      @if (gorunumAyarlariAcik) {
      <div class="sekme-icerik">
        <!-- Renk -->
        <div class="ayar-satir">
          <label>Renk:</label>
          <div class="renk-kontrol">
            <div class="renk-palette">
              @for (r of renkler; track r) {
              <div class="renk-kutu" [style.background-color]="r"
                   [class.secili]="renk === r"
                   (click)="renk = r; onizlemeGuncelle()"></div>
              }
            </div>
            <input type="color" [(ngModel)]="renk" (ngModelChange)="onizlemeGuncelle()" class="renk-input" />
          </div>
        </div>

        <!-- Font Boyutu -->
        <div class="ayar-satir">
          <label>Yazı Boyutu:</label>
          <div class="slider-kontrol">
            <input type="range" [(ngModel)]="boyut" (ngModelChange)="onizlemeGuncelle()"
                   min="8" max="24" step="1" />
            <span class="deger-gosterge">{{boyut}}px</span>
          </div>
        </div>

        <!-- Sabit Boyut -->
        <div class="ayar-satir">
          <label>Sabit Boyut:</label>
          <div class="checkbox-kontrol">
            <input type="checkbox" [(ngModel)]="sabitBoyut" (ngModelChange)="sabitBoyutDegistir()" id="sabitBoyutBayrak" class="catia-checkbox">
            <label for="sabitBoyutBayrak" class="checkbox-label">Aktif</label>
          </div>
        </div>
      </div>
      }
    </div>

  </div>

  <!-- Action Bar -->
  <div class="aksiyon-bar">
    <button class="catia-btn ekle-btn" (click)="ekle()" [disabled]="!nokta">
      <i class="icon plus"></i>
      Ekle
    </button>
    <button class="catia-btn kapat-btn" (click)="kapat()">
      <i class="icon times"></i>
      Kapat
    </button>
  </div>
</div>
